import { useState } from "react";
import axios from "axios";
import { endpoints } from "../../../utils/endpoints";
import { useStepperContext } from "../StepperContext";
import { QUERYPARAMS } from "../common";

const useManualSwap = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [resData, setResData] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const { updateData } = useStepperContext();

  const onSubmitManualSwap = async (payload) => {
    setIsLoading(true);
    setErrorMsg(null);
    setResData(null);

    if (!payload?.manualSwapType) {
      setErrorMsg("SwapType is required");
      setIsLoading(false);
      throw new Error("SwapType is required");
    }

    let swapEndpoint = endpoints.manualSwap.addManualSwap;
    if (payload.manualSwapType === QUERYPARAMS.OTA) {
      swapEndpoint = endpoints.manualSwap.otaPost;
      delete payload.reasonForSwap;
    }
    const config = {
      method: "post",
      url: swapEndpoint,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    };

    try {
      const response = await axios.request(config);

      setResData(response.data);
      setIsLoading(false);
      updateData("swapErrorRes", null);

      // Return the response data for use in handleSubmit
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      const errorMessage = error?.response?.data?.message || error.message;

      setErrorMsg(errorMessage);
      updateData("swapErrorRes", {
        code: error?.response?.status || error?.code,
        message: errorMessage,
      });
      setIsLoading(false);

      throw error;
    }
  };

  return { isLoading, resData, errorMsg, onSubmitManualSwap };
};

export default useManualSwap;
